export class CreditCardSetHiddenRequest {

    IsHidden: boolean;
    CreditCardID: number;

}
